module.exports = __webpack_public_path__ + "img/1437957498.dcfc046d.jpg";